import React, { useState } from "react";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  IconButton,
  Tooltip,
  Modal,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import baseURL from "../../../config";
import axios from "axios";

const COCmodal = ({ cocDetails }) => {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    portName: "",
    portCountry: "",
    date: "",
    contractId: "",
    ImoCrewListFile: null,
    cdcStamppageFile: null,
  });
  const [loading, setLoading] = useState(false);
  const [selectedCrewName, setSelectedCrewName] = useState("");
  const [selectedIndosNumber, setSelectIndosNumber] = useState("");
  const [selectedVesselName, setSelectVesselName] = useState("");
  const userID = localStorage.getItem("user id");

  const handleOpen = (contractId, crewName, indosno, vesselname) => {
    setFormData({
      portName: "",
      portCountry: "",
      date: "",
      contractId,
      ImoCrewListFile: null,
      cdcStamppageFile: null,
    });
    setSelectedCrewName(crewName);
    setSelectIndosNumber(indosno);
    setSelectVesselName(vesselname);
    setOpen(true);
  };

  const handleClose = () => {
    if (!loading) {
      setOpen(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prev) => ({ ...prev, [name]: files[0] }));
  };

  const handleSave = async () => {
      const { portName, portCountry, date, contractId, cdcStamppageFile, ImoCrewListFile } = formData;
  
      if (!portName || !portCountry || !date || !cdcStamppageFile || !ImoCrewListFile) {
        toast.error("All fields are required.");
        return;
      }
  
      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const form = new FormData();
  
        const signOnData = [
          { portName, portCountry, date },
        ];
  
        form.append("contractId", contractId);
        form.append("signOn", JSON.stringify(signOnData));
        form.append("signOn[0][cdcStamppageFile]", cdcStamppageFile);
        form.append("signOn[0][ImoCrewListFile]", ImoCrewListFile);
        form.append("creatorId", userID);
  
        await axios.post(`${baseURL}/api/statusAfterForm1`, form, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
  
        toast.success("Data saved successfully.");
        handleClose();
  
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } catch (error) {
        console.error("Error saving data:", error);
        toast.error("Failed to save data.");
      } finally {
        setLoading(false);
      }
    };
  

  let serialNumber = 1;

  return (
    <>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          COC Records
        </Typography>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No.</TableCell>
                <TableCell>Contract Info</TableCell>
                <TableCell>COC Date</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {cocDetails.map((item, i) => {
                const contract = item.contractDetails;
                const cocArray = item.contractStatusAfterForm1?.coc || [];

                const vesselName = contract?.ShipDetails?.vesselname || contract?.vesselName || "N/A";
                const crewName = contract?.crewdetails?.name || contract?.crewName || "N/A";
                const indosNo = contract?.crewdetails?.indosno || "N/A";
                const rankName = contract?.rank?.rankname || contract?.rankName || "N/A";

                if (!Array.isArray(cocArray) || cocArray.length === 0) return null;

                return cocArray.map((entry, index) => (
                  <TableRow key={`${i}-${index}`}>
                    <TableCell>{serialNumber++}</TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Chip label={`Vessel: ${vesselName}`} />
                        <Chip label={`Crew: ${crewName}`} />
                        <Chip label={`Indos: ${indosNo}`} />
                        <Chip label={`Rank: ${rankName}`} />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={
                          entry.Date
                            ? new Date(entry.Date).toLocaleDateString("en-GB")
                            : "N/A"
                        }
                        sx={{ bgcolor: "#e0f7fa", color: "#00796b" }}
                      />
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Add Signon">
                        <IconButton
                          onClick={() =>
                            handleOpen(
                              contract?._id || "",
                              crewName,
                              indosNo,
                              vesselName
                            )
                          }
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ));
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 450,
            p: 4,
            borderRadius: 3,
            boxShadow: 24,
          }}
        >
          <Typography variant="h6" align="center" gutterBottom>
            Enter Sign-On:{" "}
            <span style={{ color: "green" }}>
              {`${selectedCrewName} - ${selectedIndosNumber} - ${selectedVesselName}`}
            </span>
          </Typography>

          <TextField
            required
            fullWidth
            label="Port Name"
            name="portName"
            value={formData.portName}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Port Country"
            name="portCountry"
            value={formData.portCountry}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
          />

          <TextField
            required
            fullWidth
            label="Date"
            type="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
          />

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              CDC Stamp Page File *
            </Typography>
            <label htmlFor="cdc-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="cdc-upload"
                type="file"
                name="cdcStamppageFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.cdcStamppageFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={2}>
            <Typography variant="body2" gutterBottom>
              IMO Crew List File *
            </Typography>
            <label htmlFor="imo-upload">
              <input
                accept="application/pdf,image/*"
                style={{ display: "none" }}
                id="imo-upload"
                type="file"
                name="ImoCrewListFile"
                onChange={handleFileChange}
              />
              <Button variant="outlined" component="span" fullWidth>
                {formData.ImoCrewListFile?.name || "Upload File"}
              </Button>
            </label>
          </Box>

          <Box mt={3} display="flex" justifyContent="space-between">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              disabled={loading}
              startIcon={loading && <CircularProgress size={20} color="inherit" />}
            >
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
          </Box>
        </Paper>
      </Modal>

      <ToastContainer />
    </>
  );
};

export default COCmodal;
